// extracted by mini-css-extract-plugin
export default {"cellAlign":"cellAlign---i_fag","authorityIcon":"authorityIcon---wpHfX"};